import React from 'react';
import Layout from '../components/Layout';
import { useCluster } from '../context/ClusterContext';
import { PiggyBank } from 'lucide-react';

import CommitmentsTable from '../components/CommitmentsTable';

/**
 * Commitments page — the RATE-SIDE savings lever, on its own route so it doesn't
 * clutter Node Optimization.
 *
 * Two things live here:
 *   1. Manage existing RI / Savings Plan / CUD / Reserved-VM coverage
 *      (sync from cloud API, add manual, delete, expiring-soon).
 *   2. Buy/extend RECOMMENDATIONS for the uncommitted always-on on-demand
 *      baseline (WS-E Lever 3) — the capacity the engine can't move to spot,
 *      which otherwise pays full list price.
 *
 * Both are rendered by CommitmentsTable, driven by the cluster picker.
 */
export default function Commitments() {
  const { selectedCluster } = useCluster();
  const clusterId = selectedCluster?.id;

  if (!clusterId) {
    return (
      <Layout>
        <div className="flex h-64 items-center justify-center text-sm text-slate-500">
          Select a cluster to view commitments.
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="mx-auto max-w-6xl px-1">
        {/* ── Header ─────────────────────────────────────────────── */}
        <header className="flex flex-wrap items-start justify-between gap-4 pb-8">
          <div className="flex items-start gap-3">
            <div className="mt-0.5 flex h-9 w-9 items-center justify-center rounded-lg bg-slate-900 dark:bg-slate-100">
              <PiggyBank className="h-5 w-5 text-white dark:text-slate-900" />
            </div>
            <div>
              <h1 className="text-2xl font-semibold tracking-tight text-slate-900 dark:text-white">
                Commitments
              </h1>
              <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                Reserved Instances, Savings Plans &amp; CUDs for the always-on baseline of{' '}
                <span className="font-medium text-slate-700 dark:text-slate-300">
                  {selectedCluster?.name || clusterId}
                </span>{' '}
                — the capacity spot can&apos;t cover.
              </p>
            </div>
          </div>
        </header>

        <div className="grid grid-cols-1 gap-5">
          <CommitmentsTable clusterId={clusterId} />
        </div>
      </div>
    </Layout>
  );
}
